import React from 'react';
import './styles.css';

const AttractionCard = (props) => {
    const { name, description, isOpen, pic } = props;
    return (
        <div className="flex-item">
            <img src={pic} alt={`image of ${name}`} className="attraction-images" />
            <div>
                <h4>{name}</h4>
                <div>
                    <p>{description}</p>
                    <p>
                        <b>Covid Restrictions: </b>
                        <span>{isOpen ? 'None' : 'Temporarily Closed'}</span>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default AttractionCard;